import {
  __name
} from "./chunk-2IB33T4A.js";

// src/utils.ts
import { schema } from "@acme/core";
import { createMongoAbility } from "@casl/ability";
import { z } from "zod";
function separateWords(str) {
  if (str.includes("--")) str = str.split("--")[0];
  const separated = str.replace(/([a-z])([A-Z])/g, "$1 $2").split(" ");
  let result = "";
  for (const word of separated) {
    if (word === word.toUpperCase()) result += word + " ";
    else if (separated.indexOf(word) === 0) result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + " ";
    else result += word.toLowerCase() + " ";
  }
  return result.trim();
}
__name(separateWords, "separateWords");
function createHref(prefix, str) {
  const regex = /([a-z])([A-Z])/g;
  return `/${prefix}/${str.replace(regex, "$1-$2")}`.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\/\//, "/").toLowerCase();
}
__name(createHref, "createHref");
function createPermissionRoutes(baseObj, prefix) {
  const routes9 = {};
  for (const key of Object.keys(baseObj)) {
    const value = baseObj[key];
    routes9[key] = {
      href: createHref(prefix, String(key)),
      subject: value.subject,
      label: value.label,
      showInMenu: value.showInMenu ?? true
    };
  }
  return routes9;
}
__name(createPermissionRoutes, "createPermissionRoutes");
function LiteralDefault(value) {
  return z.literal(value).default(value);
}
__name(LiteralDefault, "LiteralDefault");
function defineZodRoute(route, permissions, parser) {
  const subject = LiteralDefault(route);
  if (!parser) return {
    route: z.tuple([
      permissions,
      subject
    ]),
    subject
  };
  if (Array.isArray(parser)) return {
    route: z.tuple([
      permissions,
      z.union(
        // @ts-expect-error - parser is an array
        subject,
        ...parser.map((p) => schema[p].extend({
          __typename: subject
        }))
      )
    ]),
    subject
  };
  return {
    route: z.tuple([
      permissions,
      z.union([
        subject,
        schema[parser].extend({
          __typename: subject
        })
      ])
    ]),
    subject
  };
}
__name(defineZodRoute, "defineZodRoute");
var createAppAbility = createMongoAbility;
function pick(object, props) {
  if (!object || typeof object !== "object") return {};
  return Object.fromEntries(props.map((key) => [
    key,
    object[key]
  ]));
}
__name(pick, "pick");

// src/subjects/administracao.ts
import { z as z3 } from "zod";

// src/subjects/_actions.ts
import { z as z2 } from "zod";
var crud = z2.enum([
  "create",
  "read",
  "update",
  "delete"
]);
var readOnly = z2.enum([
  "read"
]);
var cannotDelete = z2.enum([
  "create",
  "read",
  "update"
]);
var readUpdate = z2.enum([
  "read",
  "update"
]);
var updateOnly = z2.enum([
  "update"
]);
var readCreate = z2.enum([
  "read",
  "create"
]);
var readDelete = z2.enum([
  "read",
  "delete"
]);
var cannotRead = z2.enum([
  "create",
  "update",
  "delete"
]);
var cannotUpdate = z2.enum([
  "create",
  "read",
  "delete"
]);

// src/subjects/administracao.ts
var { route: clientes, subject: clientesSubject } = defineZodRoute("Clientes", cannotDelete, "ClienteSchema");
var { route: usuarios, subject: usuariosSubject } = defineZodRoute("Usu\xE1rios", crud, "UsuarioSchema");
var { route: reajustes, subject: reajustesSubject } = defineZodRoute("Reajustes", cannotDelete, "ReajusteAnualSchema");
var { route: certificados, subject: certificadosSubject } = defineZodRoute("Certificados", crud);
var { route: termosPoliticas, subject: termosPoliticasSubject } = defineZodRoute("TermosEPol\xEDtica", crud);
var { route: notificacoes, subject: notificacoesSubject } = defineZodRoute("Notifica\xE7\xF5es", cannotDelete);
var { route: planosPrecos, subject: planosPrecosSubject } = defineZodRoute("Planos e pre\xE7os", cannotDelete);
var { route: dashboardAdministrativo, subject: dashboardAdministrativoSubject } = defineZodRoute("DashboardAdministrativo", readOnly);
var subjects = z3.union([
  clientes,
  usuarios,
  reajustes,
  planosPrecos,
  certificados,
  termosPoliticas,
  notificacoes,
  dashboardAdministrativo
]);
var routes = {
  clientes: {
    subject: clientesSubject._def.defaultValue(),
    label: "Clientes"
  },
  usuarios: {
    subject: usuariosSubject._def.defaultValue(),
    label: "Usu\xE1rios"
  },
  reajustesAnuais: {
    subject: reajustesSubject._def.defaultValue(),
    label: "Reajustes anuais"
  },
  planosPrecos: {
    subject: planosPrecosSubject._def.defaultValue(),
    label: "Planos e pre\xE7os"
  },
  certificados: {
    subject: certificadosSubject._def.defaultValue(),
    label: "Certificados"
  },
  termosPoliticas: {
    subject: termosPoliticasSubject._def.defaultValue(),
    label: "Termos e pol\xEDtica"
  },
  notificacoes: {
    subject: notificacoesSubject._def.defaultValue(),
    label: "Notifica\xE7\xF5es"
  },
  dashboardAdministrativo: {
    subject: dashboardAdministrativoSubject._def.defaultValue(),
    label: "Dashboard administrativo"
  }
};
var administracao = createPermissionRoutes(routes, "administracao");

// src/subjects/ajuda.ts
import { z as z4 } from "zod";
var { route: atendimentoOnline, subject: atendimentoOnlineSubject } = defineZodRoute("AtendimentoOnline", readOnly);
var { route: manual, subject: manualSubject } = defineZodRoute("Manual", readOnly);
var { route: primeirosPassos, subject: primeirosPassosSubject } = defineZodRoute("PrimeirosPassos", readOnly);
var subjects2 = z4.union([
  atendimentoOnline,
  manual,
  primeirosPassos
]);
var routes2 = {
  atendimentoOnline: {
    subject: atendimentoOnlineSubject._def.defaultValue(),
    label: "Atendimento online"
  },
  manual: {
    subject: manualSubject._def.defaultValue(),
    label: "Manual"
  },
  primeirosPassos: {
    subject: primeirosPassosSubject._def.defaultValue(),
    label: "Primeiros passos"
  }
};
var ajuda = createPermissionRoutes(routes2, "ajuda");

// src/subjects/ajustes-ponto.ts
import { z as z5 } from "zod";
var { route: registros, subject: registrosSubject } = defineZodRoute("Registros", cannotRead);
var { route: abonos, subject: abonosSubject } = defineZodRoute("Abonos", cannotRead);
var { route: afastamentos, subject: afastamentosSubject } = defineZodRoute("Afastamentos", cannotRead);
var { route: compensacao, subject: compensacaoSubject } = defineZodRoute("Compensa\xE7\xE3o", cannotRead);
var { route: amamentacao, subject: amamentacaoSubject } = defineZodRoute("Amamenta\xE7\xE3o", cannotRead);
var { route: folga, subject: folgaSubject } = defineZodRoute("Folga", cannotRead);
var { route: compensacaoFeriados, subject: compensacaoFeriadosSubject } = defineZodRoute("Compensa\xE7\xE3oDeFeriados", cannotRead);
var { route: compensacaoFolgas, subject: compensacaoFolgasSubject } = defineZodRoute("Compensa\xE7\xE3oDeFolgas", cannotRead);
var { route: faltas, subject: faltasSubject } = defineZodRoute("FaltasJustificadasOuInjustificadas", cannotRead);
var subjects3 = z5.union([
  registros,
  abonos,
  afastamentos,
  compensacao,
  amamentacao,
  folga,
  compensacaoFeriados,
  compensacaoFolgas,
  faltas
]);
var routes3 = {
  registros: {
    subject: registrosSubject._def.defaultValue(),
    label: "Registros",
    showInMenu: false
  },
  abonos: {
    subject: abonosSubject._def.defaultValue(),
    label: "Abonos",
    showInMenu: false
  },
  afastamentos: {
    subject: afastamentosSubject._def.defaultValue(),
    label: "Afastamentos",
    showInMenu: false
  },
  compensacao: {
    subject: compensacaoSubject._def.defaultValue(),
    label: "Compensa\xE7\xE3o",
    showInMenu: false
  },
  amamentacao: {
    subject: amamentacaoSubject._def.defaultValue(),
    label: "Amamenta\xE7\xE3o",
    showInMenu: false
  },
  folga: {
    subject: folgaSubject._def.defaultValue(),
    label: "Folga",
    showInMenu: false
  },
  compensacaoFeriados: {
    subject: compensacaoFeriadosSubject._def.defaultValue(),
    label: "Compensa\xE7\xE3o de feriados",
    showInMenu: false
  },
  compensacaoFolgas: {
    subject: compensacaoFolgasSubject._def.defaultValue(),
    label: "Compensa\xE7\xE3o de folgas",
    showInMenu: false
  },
  faltas: {
    subject: faltasSubject._def.defaultValue(),
    label: "Faltas justificadas ou injustificadas",
    showInMenu: false
  }
};
var ajustesPonto = createPermissionRoutes(routes3, "");

// src/subjects/cadastros.ts
import { z as z6 } from "zod";
var { route: centroCusto, subject: centroCustoSubject } = defineZodRoute("CentrosDeCusto", crud, "CentroCustoSchema");
var { route: empresas, subject: empresasSubject } = defineZodRoute("Empresas", crud, "EmpresaSchema");
var { route: escalas, subject: escalasSubject } = defineZodRoute("Escalas", crud, "EscalaTrabalhoSchema");
var { route: feriados, subject: feriadosSubject } = defineZodRoute("Feriados", crud, [
  "FeriadosClienteSchema",
  "FeriadosNacionaisEstaduaisSchema"
]);
var { route: funcionarios, subject: funcionarioSubject } = defineZodRoute("Funcion\xE1rios", crud, "FuncionarioSchema");
var { route: locais, subject: locaisSubject } = defineZodRoute("Locais", crud, "LocalSchema");
var { route: ocorrencias, subject: ocorrenciasSubject } = defineZodRoute("Ocorr\xEAncias", crud, "OcorrenciaSchema");
var { route: regrasCalculo, subject: regrasCalculoSubject } = defineZodRoute("RegrasDeC\xE1lculo", crud, "RegrasCalculoSchema");
var { route: rubricas, subject: rubricasSubject } = defineZodRoute("Rubricas", readUpdate, "RubricaSchema");
var { route: rotinas, subject: rotinasSubject } = defineZodRoute("Rotinas", crud, "RotinaSchema");
var { route: supervisores, subject: supervisoresSubject } = defineZodRoute("Supervisores", crud, "SupervisorSchema");
var { route: tabelaHorarios, subject: tabelaHorariosSubject } = defineZodRoute("TabelaDeHor\xE1rios", crud, "TabelaHorarioSchema");
var { route: permissoes, subject: permissoesSubject } = defineZodRoute("Permiss\xF5es", crud, "PerfilPermissaoSchema");
var subjects4 = z6.union([
  centroCusto,
  empresas,
  escalas,
  feriados,
  funcionarios,
  locais,
  ocorrencias,
  regrasCalculo,
  rubricas,
  rotinas,
  supervisores,
  tabelaHorarios,
  permissoes
]);
var routes4 = {
  centroCusto: {
    subject: centroCustoSubject._def.defaultValue(),
    label: "Centros de custo"
  },
  empresas: {
    subject: empresasSubject._def.defaultValue(),
    label: "Empresas"
  },
  escalas: {
    subject: escalasSubject._def.defaultValue(),
    label: "Escalas"
  },
  feriados: {
    subject: feriadosSubject._def.defaultValue(),
    label: "Feriados"
  },
  funcionarios: {
    subject: funcionarioSubject._def.defaultValue(),
    label: "Funcion\xE1rios"
  },
  locais: {
    subject: locaisSubject._def.defaultValue(),
    label: "Locais"
  },
  ocorrencias: {
    subject: ocorrenciasSubject._def.defaultValue(),
    label: "Ocorr\xEAncias"
  },
  regrasCalculo: {
    subject: regrasCalculoSubject._def.defaultValue(),
    label: "Regras de c\xE1lculo"
  },
  rubricas: {
    subject: rubricasSubject._def.defaultValue(),
    label: "Rubricas"
  },
  rotinas: {
    subject: rotinasSubject._def.defaultValue(),
    label: "Rotinas"
  },
  supervisores: {
    subject: supervisoresSubject._def.defaultValue(),
    label: "Supervisores"
  },
  tabelaHorarios: {
    subject: tabelaHorariosSubject._def.defaultValue(),
    label: "Tabela de hor\xE1rios"
  },
  permissoes: {
    subject: permissoesSubject._def.defaultValue(),
    label: "Permiss\xF5es"
  }
};
var cadastros = createPermissionRoutes(routes4, "cadastros");

// src/subjects/integracoes.ts
import { z as z7 } from "zod";
var { route: aej, subject: aejSubject } = defineZodRoute("AEJ", crud);
var { route: folhaPagamento, subject: folhaPagamentoSubject } = defineZodRoute("FolhaDePagamento", readCreate);
var { route: afd, subject: afdSubject } = defineZodRoute("AFD", readCreate);
var { route: importarFuncionarios, subject: importarFuncionariosSubject } = defineZodRoute("ImportarFuncion\xE1rios", readOnly, "FuncionarioSchema");
var { route: reps, subject: repsSubject } = defineZodRoute("Reps", crud, "RepSchema");
var { route: exportarFuncionarios, subject: exportarFuncionariosSubject } = defineZodRoute("ExportarFuncion\xE1rios", readOnly, "FuncionarioSchema");
var { route: credenciaisApi, subject: credenciaisApiSubject } = defineZodRoute("CredenciaisDeAPI", crud);
var subjects5 = z7.union([
  aej,
  folhaPagamento,
  afd,
  importarFuncionarios,
  reps,
  exportarFuncionarios,
  credenciaisApi
]);
var routes5 = {
  aej: {
    subject: aejSubject._def.defaultValue(),
    label: "AEJ"
  },
  folhaPagamento: {
    subject: folhaPagamentoSubject._def.defaultValue(),
    label: "Folha de pagamento"
  },
  afd: {
    subject: afdSubject._def.defaultValue(),
    label: "AFD"
  },
  importarFuncionarios: {
    subject: importarFuncionariosSubject._def.defaultValue(),
    label: "Importar funcion\xE1rios"
  },
  reps: {
    subject: repsSubject._def.defaultValue(),
    label: "REPs"
  },
  exportarFuncionarios: {
    subject: exportarFuncionariosSubject._def.defaultValue(),
    label: "Exportar funcion\xE1rios"
  },
  credenciaisApi: {
    subject: credenciaisApiSubject._def.defaultValue(),
    label: "Credenciais de API"
  }
};
var integracoes = createPermissionRoutes(routes5, "integracoes");

// src/subjects/manutencao_ponto.ts
import { z as z8 } from "zod";
var { route: calculoPonto, subject: calculoPontoSubject } = defineZodRoute("C\xE1lculoDoPonto", crud, "CalculoSchema");
var { route: digitacao, subject: digitacaoSubject } = defineZodRoute("Digita\xE7\xE3o", readOnly);
var { route: implantacao, subject: implantacaoSubject } = defineZodRoute("Implanta\xE7\xE3oDoBancoDeHoras", crud, "SaldoHorasSchema");
var { route: sobreaviso, subject: sobreavisoSubject } = defineZodRoute("Sobreaviso", crud, "SobreavisoSchema");
var { route: trocaDiaTrabalho, subject: trocaDiaTrabalhoSubject } = defineZodRoute("TrocaDeDiaDeTrabalho", crud, "TrocaDiaTrabalhoSchema");
var { route: trocaTabelaHorario, subject: trocaTabelaHorarioSubject } = defineZodRoute("TrocaDeTabelaDeHor\xE1rio", crud, "TabelaHorarioFuncionarioSchema");
var { route: fechamentoCompetencia, subject: fechamentoCompetenciaSubject } = defineZodRoute("FechamentoDeCompet\xEAncia", readCreate, "FechamentoCompetenciaSchema");
var { route: ajustesPonto2, subject: ajustesPontoSubject } = defineZodRoute("AjustesDePonto", readOnly);
var { route: pagamentoHoras, subject: pagamentohorasSubject } = defineZodRoute("PagamentoDeHoras", readUpdate, "PagamentoHorasSchema");
var { route: ausencias, subject: ausenciasSubject } = defineZodRoute("Aus\xEAncias", readOnly);
var { route: trocaAutomaticaHorario, subject: trocaAutomaticaHorarioSubject } = defineZodRoute("TrocaAutom\xE1ticaDeHor\xE1rio", crud);
var { route: compensacaoManual, subject: compensacaoManualSubject } = defineZodRoute("Compensa\xE7\xE3oManual", crud);
var subjects6 = z8.union([
  calculoPonto,
  digitacao,
  implantacao,
  sobreaviso,
  trocaDiaTrabalho,
  trocaTabelaHorario,
  fechamentoCompetencia,
  ajustesPonto2,
  pagamentoHoras,
  ausencias,
  trocaAutomaticaHorario,
  compensacaoManual
]);
var routes6 = {
  calculoPonto: {
    subject: calculoPontoSubject._def.defaultValue(),
    label: "C\xE1lculo do ponto"
  },
  digitacao: {
    subject: digitacaoSubject._def.defaultValue(),
    label: "Digita\xE7\xE3o"
  },
  bancoHoras: {
    subject: implantacaoSubject._def.defaultValue(),
    label: "Implanta\xE7\xE3o do banco de horas"
  },
  sobreaviso: {
    subject: sobreavisoSubject._def.defaultValue(),
    label: "Sobreaviso"
  },
  trocaDiaTrabalho: {
    subject: trocaDiaTrabalhoSubject._def.defaultValue(),
    label: "Troca de dia de trabalho"
  },
  trocaTabelaHorario: {
    subject: trocaTabelaHorarioSubject._def.defaultValue(),
    label: "Troca de tabela de hor\xE1rio"
  },
  fechamentoCompetencia: {
    subject: fechamentoCompetenciaSubject._def.defaultValue(),
    label: "Fechamento de compet\xEAncia"
  },
  ajustesPonto: {
    subject: ajustesPontoSubject._def.defaultValue(),
    label: "Ajustes de ponto"
  },
  pagamentoHoras: {
    subject: pagamentohorasSubject._def.defaultValue(),
    label: "Pagamento de horas"
  },
  ausencias: {
    subject: ausenciasSubject._def.defaultValue(),
    label: "Aus\xEAncias"
  },
  trocaAutomaticaHorario: {
    subject: trocaAutomaticaHorarioSubject._def.defaultValue(),
    label: "Troca autom\xE1tica de hor\xE1rio"
  },
  compensacaoManual: {
    subject: compensacaoManualSubject._def.defaultValue(),
    label: "Compensa\xE7\xE3o manual"
  }
};
var manutencaoPonto = createPermissionRoutes(routes6, "manutencao-ponto");

// src/subjects/notListed.ts
import { z as z9 } from "zod";
var { route: selecionarFuncionario, subject: selecionarFuncionarioSubject } = defineZodRoute("SelecionarFuncion\xE1rio", readOnly);
var { route: planos, subject: planosSubject } = defineZodRoute("Planos", readOnly);
var { route: perfil, subject: perfilSubject } = defineZodRoute("Perfil", readUpdate);
var { route: alteracoes, subject: alteracoesSubject } = defineZodRoute("Altera\xE7\xF5es", readOnly);
var { route: historicoLogin, subject: historicoLoginSubject } = defineZodRoute("Hist\xF3ricoDeLogin", readDelete);
var { route: checkout, subject: checkoutSubject } = defineZodRoute("Checkout", readOnly);
var { route: dashboard, subject: dashboardSubject } = defineZodRoute("Dashboard", readOnly);
var { route: atestadoTecnico, subject: atestadoTecnicoSubject } = defineZodRoute("AtestadoDeCapacidadeT\xE9cnica", readOnly);
var { route: ajustesImpressos, subject: AssinaturaEletronicaDeAjustesSubject } = defineZodRoute("AssinaturaEletr\xF4nicaDeAjustes", crud);
var { route: edicaoManualEspelho, subject: EdicaoManualDoEspelhoDoPontoSubject } = defineZodRoute("Edi\xE7\xE3oManualDoEspelhoDoPonto", updateOnly);
var { route: treinamentos, subject: treinamentosSubject } = defineZodRoute("Treinamentos", crud);
var { route: credenciaisApiCliente, subject: credenciaisApiClienteSubject } = defineZodRoute("CredenciaisDeAPIDoCliente", readUpdate);
var { route: notasAdesivas, subject: notasAdesivasSubject } = defineZodRoute("NotasAdesivas", crud);
var subjects7 = z9.union([
  selecionarFuncionario,
  planos,
  perfil,
  alteracoes,
  historicoLogin,
  checkout,
  dashboard,
  atestadoTecnico,
  ajustesImpressos,
  edicaoManualEspelho,
  treinamentos,
  credenciaisApiCliente,
  notasAdesivas
]);
var routes7 = {
  selecionarFuncionario: {
    subject: selecionarFuncionarioSubject._def.defaultValue(),
    label: "Selecionar funcion\xE1rio",
    showInMenu: false
  },
  planos: {
    subject: planosSubject._def.defaultValue(),
    label: "Planos",
    showInMenu: false
  },
  perfil: {
    subject: perfilSubject._def.defaultValue(),
    label: "Perfil",
    showInMenu: false
  },
  alteracoes: {
    subject: alteracoesSubject._def.defaultValue(),
    label: "Altera\xE7\xF5es",
    showInMenu: false
  },
  historicoLogin: {
    subject: historicoLoginSubject._def.defaultValue(),
    label: "Hist\xF3rico de login",
    showInMenu: false
  },
  checkout: {
    subject: checkoutSubject._def.defaultValue(),
    label: "Checkout",
    showInMenu: false
  },
  dashboard: {
    subject: dashboardSubject._def.defaultValue(),
    label: "Dashboard",
    showInMenu: false
  },
  atestadoTecnico: {
    subject: atestadoTecnicoSubject._def.defaultValue(),
    label: "Atestado de capacidade t\xE9cnica",
    showInMenu: false
  },
  ajustesImpressos: {
    subject: AssinaturaEletronicaDeAjustesSubject._def.defaultValue(),
    label: "Assinatura eletr\xF4nica de ajustes",
    showInMenu: false
  },
  edicaoManualEspelho: {
    subject: EdicaoManualDoEspelhoDoPontoSubject._def.defaultValue(),
    label: "Edi\xE7\xE3o manual do espelho do ponto",
    showInMenu: false
  },
  treinamentos: {
    subject: treinamentosSubject._def.defaultValue(),
    label: "Treinamentos",
    showInMenu: false
  },
  credenciaisApiCliente: {
    subject: credenciaisApiClienteSubject._def.defaultValue(),
    label: "Credenciais de API do cliente",
    showInMenu: false
  },
  notasAdesivas: {
    subject: notasAdesivasSubject._def.defaultValue(),
    label: "Notas adesivas",
    showInMenu: false
  }
};
var notListed = createPermissionRoutes(routes7, "");

// src/subjects/relatorios.ts
import { z as z10 } from "zod";
var { route: adicionalNoturno, subject: adicionalNoturnoSubject } = defineZodRoute("AdicionalNoturno", readOnly);
var { route: saldoHoras, subject: saldoHorasSubject } = defineZodRoute("SaldoDeHoras", readOnly, "SaldoHorasSchema");
var { route: espelhoPonto, subject: espelhoPontoSubject } = defineZodRoute("EspelhoDoPonto", readUpdate, "EspelhoPontoSchema");
var { route: inconsistencias, subject: inconsistenciasSubject } = defineZodRoute("Inconsist\xEAncias", readOnly);
var { route: valeAlimentacao, subject: valeAlimentacaoSubject } = defineZodRoute("ValeAlimenta\xE7\xE3o", readUpdate, "ValeAlimentacaoSchema");
var { route: absenteismo, subject: absenteismoSubject } = defineZodRoute("Absente\xEDsmo", readOnly);
var { route: registrosForaCerca, subject: registrosForaCercaSubject } = defineZodRoute("RegistrosForaDaCerca", readOnly, "RegistroSchema");
var { route: ajustes, subject: ajustesSubject } = defineZodRoute("Ajustes", cannotUpdate);
var { route: aceiteEspelho, subject: aceiteEspelhoSubject } = defineZodRoute("AceiteDoEspelhoDoPonto", cannotDelete);
var { route: registrosExcluidos, subject: registrosExcluidosSubject } = defineZodRoute("RegistrosExclu\xEDdos", readOnly, "RegistroSchema");
var { route: comprovantePonto, subject: comprovantePontoSubject } = defineZodRoute("ComprovanteDePonto", readOnly);
var { route: descontoDSR, subject: descontoDSRSubject } = defineZodRoute("DescontoDeDSR", readOnly, "DescontoDsrSchema");
var { route: horasTrabalhadas, subject: horasTrabalhadasSubject } = defineZodRoute("HorasTrabalhadas", readOnly);
var { route: horasSuprimidas, subject: horasSuprimidasSubject } = defineZodRoute("HorasSuprimidas", readOnly);
var { route: pontoDiario, subject: pontoDiarioSubject } = defineZodRoute("PontoDi\xE1rio", readOnly);
var { route: dashboardItems, subject: dashboardItemsSubject } = defineZodRoute("Dashboard--Items", readOnly);
var { route: faltasAtrasos, subject: faltasAtrasosSubject } = defineZodRoute("RelatorioFaltasAtrasos", readOnly);
var { route: vencimentoBanco, subject: vencimentoBancoSubject } = defineZodRoute("VencimentoDoBancoDeHoras", readOnly);
var { route: espelhoPeriodo, subject: espelhoPeriodoSubject } = defineZodRoute("EspelhoPontoPorPer\xEDodo", cannotUpdate);
var { route: comissoes, subject: comissoesSubject } = defineZodRoute("RelatorioComissoes", readOnly);
var { route: logs, subject: logsSubject } = defineZodRoute("Logs", readOnly);
var { route: auditoria, subject: auditoriaSubject } = defineZodRoute("Auditoria", readOnly);
var { route: dashboard2, subject: dashboardSubject2 } = defineZodRoute("Dashboard--Items", readOnly);
var subjects8 = z10.union([
  adicionalNoturno,
  saldoHoras,
  espelhoPonto,
  inconsistencias,
  valeAlimentacao,
  absenteismo,
  registrosForaCerca,
  ajustes,
  aceiteEspelho,
  registrosExcluidos,
  comprovantePonto,
  descontoDSR,
  horasTrabalhadas,
  horasSuprimidas,
  pontoDiario,
  dashboardItems,
  faltasAtrasos,
  dashboard2,
  faltasAtrasos,
  vencimentoBanco,
  espelhoPeriodo,
  comissoes,
  logs,
  auditoria
]);
var routes8 = {
  adicionalNoturno: {
    subject: adicionalNoturnoSubject._def.defaultValue(),
    label: "Adicional noturno"
  },
  saldoHoras: {
    subject: saldoHorasSubject._def.defaultValue(),
    label: "Saldo de horas"
  },
  espelhoPonto: {
    subject: espelhoPontoSubject._def.defaultValue(),
    label: "Espelho do ponto"
  },
  inconsistencias: {
    subject: inconsistenciasSubject._def.defaultValue(),
    label: "Inconsist\xEAncias"
  },
  valeAlimentacao: {
    subject: valeAlimentacaoSubject._def.defaultValue(),
    label: "Vale alimenta\xE7\xE3o"
  },
  absenteismo: {
    subject: absenteismoSubject._def.defaultValue(),
    label: "Absente\xEDsmo"
  },
  registrosForaCerca: {
    subject: registrosForaCercaSubject._def.defaultValue(),
    label: "Registros fora da cerca"
  },
  ajustes: {
    subject: ajustesSubject._def.defaultValue(),
    label: "Ajustes"
  },
  aceiteEspelho: {
    subject: aceiteEspelhoSubject._def.defaultValue(),
    label: "Aceite do espelho do ponto"
  },
  registrosExcluidos: {
    subject: registrosExcluidosSubject._def.defaultValue(),
    label: "Registros exclu\xEDdos"
  },
  comprovantePonto: {
    subject: comprovantePontoSubject._def.defaultValue(),
    label: "Comprovante de ponto"
  },
  descontoDSR: {
    subject: descontoDSRSubject._def.defaultValue(),
    label: "Desconto de DSR"
  },
  horasTrabalhadas: {
    subject: horasTrabalhadasSubject._def.defaultValue(),
    label: "Horas trabalhadas"
  },
  horasSuprimidas: {
    subject: horasSuprimidasSubject._def.defaultValue(),
    label: "Horas suprimidas"
  },
  pontoDiario: {
    subject: pontoDiarioSubject._def.defaultValue(),
    label: "Ponto di\xE1rio"
  },
  dashboard: {
    subject: dashboardItemsSubject._def.defaultValue(),
    label: "Itens do dashboard"
  },
  faltasAtrasos: {
    subject: faltasAtrasosSubject._def.defaultValue(),
    label: "Faltas e atrasos"
  },
  vencimentoBanco: {
    subject: vencimentoBancoSubject._def.defaultValue(),
    label: "Vencimento do banco de horas"
  },
  espelhoPeriodo: {
    subject: espelhoPeriodoSubject._def.defaultValue(),
    label: "Espelho de ponto por per\xEDodo"
  },
  comissoes: {
    subject: comissoesSubject._def.defaultValue(),
    label: "Comiss\xF5es"
  },
  logs: {
    subject: logsSubject._def.defaultValue(),
    label: "Logs"
  },
  auditoria: {
    subject: auditoriaSubject._def.defaultValue(),
    label: "Auditoria"
  }
};
var relatorios = createPermissionRoutes(routes8, "relatorios");

// src/modules.ts
var MODULOS = {
  Administra\u00E7\u00E3o: administracao,
  Cadastros: cadastros,
  "Manuten\xE7\xE3o do ponto": manutencaoPonto,
  Integra\u00E7\u00F5es: integracoes,
  Relat\u00F3rios: relatorios,
  Ajuda: ajuda
};
var naoListadas = notListed;
var MODULOS_EXTRAS = {
  AceiteDoEspelhoDoPonto: MODULOS.Relat\u00F3rios.aceiteEspelho,
  AssinaturaEletr\u00F4nicaDeAjustes: naoListadas.ajustesImpressos,
  Edi\u00E7\u00E3oManualDoEspelhoDoPonto: naoListadas.edicaoManualEspelho,
  NotasAdesivas: naoListadas.notasAdesivas,
  IntegracaoViaAPI: MODULOS.Integra\u00E7\u00F5es.credenciaisApi,
  Rotinas: MODULOS.Cadastros.rotinas
};
var ajustesPonto3 = ajustesPonto;
var allPermissionEntries = [
  ...Object.values(MODULOS).flatMap((module) => Object.values(module)),
  ...Object.values(naoListadas),
  ...Object.values(ajustesPonto3)
];
function getPermissionLabel(subject) {
  return allPermissionEntries.find((entry) => entry.subject === subject)?.label ?? subject;
}
__name(getPermissionLabel, "getPermissionLabel");
function groupAbilitiesByModule(appAbilities) {
  return appAbilities.reduce((acc, { subject, abilities }) => {
    const module = Object.entries({
      ...MODULOS,
      Outros: pick(naoListadas, [
        "alteracoes",
        "edicaoManualEspelho",
        "notasAdesivas"
      ]),
      "Ajustes de ponto": ajustesPonto3
    }).find(([_, subjects9]) => Object.values(subjects9).some((route) => route.subject === subject));
    if (!module) return acc;
    const [moduleName] = module;
    if (!acc[moduleName]) acc[moduleName] = [];
    acc[moduleName].push({
      subject,
      abilities
    });
    return acc;
  }, {});
}
__name(groupAbilitiesByModule, "groupAbilitiesByModule");
var modules_default = MODULOS;

export {
  separateWords,
  createAppAbility,
  naoListadas,
  MODULOS_EXTRAS,
  ajustesPonto3 as ajustesPonto,
  getPermissionLabel,
  groupAbilitiesByModule,
  modules_default
};
//# sourceMappingURL=chunk-ZYNH4OIS.js.map